import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";
import { SidebarContext } from "contexts/SidebarContext";
import PropTypes from "prop-types";
import React, { useContext, useState, useEffect } from "react";
import { CgMenuRight } from "react-icons/cg";
import AdminNavbarLinks from "./AdminNavbarLinks";

export default function AdminNavbar(props) {
  const [scrolled, setScrolled] = useState(false);
  const {
    sidebarWidth,
    setSidebarWidth,
    toggleSidebar,
    setToggleSidebar,
  } = useContext(SidebarContext);
  const {
    fixed,
    secondary,
    breadcrumbs = [],
    logoText,
    onOpen,
  } = props;

  let mainText = useColorModeValue("gray.700", "gray.200");
  let navbarPosition = "absolute";
  let navbarFilter = "none";
  let navbarBackdrop = "blur(21px)";
  let navbarShadow = "none";
  let navbarBg = "none";
  let navbarBorder = "transparent";
  let secondaryMargin = "0px";
  let paddingS = "15px";
  let paddingX = "15px";

  if (fixed && scrolled) {
    navbarPosition = "fixed";
    navbarShadow = useColorModeValue(
      "0px 7px 23px rgba(0, 0, 0, 0.05)",
      "none"
    );
    navbarBg = useColorModeValue(
      "linear-gradient(112.83deg, rgba(255, 255, 255, 0.82) 0%, rgba(255, 255, 255, 0.8) 110.84%)",
      "linear-gradient(112.83deg, rgba(255, 255, 255, 0.21) 0%, rgba(255, 255, 255, 0) 110.84%)"
    );
    navbarBorder = useColorModeValue("#FFFFFF", "rgba(255, 255, 255, 0.31)");
    navbarFilter = useColorModeValue("none", "drop-shadow(...)");
  }

  if (secondary) {
    navbarBackdrop = "none";
    navbarPosition = "absolute";
    mainText = "white";
    secondaryMargin = "22px";
    paddingS = "40px";
    paddingX = "30px";
  }

  const changeNavbar = () => {
    setScrolled(window.scrollY > 1);
  };

  useEffect(() => {
    window.addEventListener("scroll", changeNavbar);
    return () => window.removeEventListener("scroll", changeNavbar);
  }, []);

  return (
    <Flex
      position={navbarPosition}
      boxShadow={navbarShadow}
      bg={navbarBg}
      borderColor={navbarBorder}
      filter={navbarFilter}
      backdropFilter={navbarBackdrop}
      borderWidth="1.5px"
      borderStyle="solid"
      transitionDelay="0s"
      transitionDuration="0.25s"
      transitionProperty="box-shadow, background-color, filter, border"
      transitionTimingFunction="linear"
      alignItems={{ xl: "center" }}
      borderRadius="16px"
      display="flex"
      minH="75px"
      left={document.documentElement.dir === "rtl" ? "30px" : ""}
      right={document.documentElement.dir === "rtl" ? "" : "30px"}
      justifyContent={{ xl: "center" }}
      mx="auto"
      mt={secondaryMargin}
      pb="8px"
      px={{ sm: paddingX, md: "0px" }}
      ps={{ sm: paddingS, md: "0px" }}
      pt="8px"
      top="18px"
      w={{
        sm: "calc(100vw - 30px)",
        xl: `calc(100vw - 75px - ${sidebarWidth}px)`,
      }}
    >
      <Flex w="100%" flexDirection={{ sm: "column", md: "row" }} alignItems="center">
        <Box>
        <Breadcrumb separator="/" spacing="8px">
  {breadcrumbs?.map((item, index) => (
    <BreadcrumbItem key={index} isCurrentPage={item.isCurrent}>
      <BreadcrumbLink
        onClick={(e) => {
          e.preventDefault();
          if (!item.isCurrent && item.onClick) item.onClick();
        }}
        fontFamily="Roboto, sans-serif"
        fontStyle="normal"
        fontWeight={item.isCurrent ? "700" : "400"}
        fontSize="16px"
        lineHeight="26px"
        color={item.isCurrent ? "rgb(31, 39, 51)" : "rgb(160, 174, 192)"}
        textDecoration="none"
        cursor={item.isCurrent ? "default" : "pointer"}
        _hover={{
          textDecoration: item.isCurrent ? "none" : "underline",
          color: "rgb(160, 174, 192)",
        }}
        _focus={{ boxShadow: "none" }}
      >
        {item.label}
      </BreadcrumbLink>
    </BreadcrumbItem>
  ))}
</Breadcrumb>


        </Box>

        {toggleSidebar && (
          <Icon
            as={CgMenuRight}
            w="100px"
            h="20px"
            ms="20px"
            cursor="pointer"
            display={{ sm: "none", xl: "block" }}
            onClick={() => {
              setSidebarWidth(sidebarWidth === 275 ? 120 : 275);
              setToggleSidebar(!toggleSidebar);
            }}
          />
        )}

        <Box ms="auto">
          <AdminNavbarLinks
            onOpen={onOpen}
            logoText={logoText}
            secondary={secondary}
            fixed={fixed}
          />
        </Box>
      </Flex>
    </Flex>
  );
}

AdminNavbar.propTypes = {
  logoText: PropTypes.string,
  breadcrumbs: PropTypes.array,
  variant: PropTypes.string,
  secondary: PropTypes.bool,
  fixed: PropTypes.bool,
  onOpen: PropTypes.func,
};
